import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

const state = {
  currentLocale: 'sv',
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
